import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import api from '../../service/api';
import {
  Paper, Tooltip, IconButton, TablePagination, Button, Typography,
  Stack,
  Grid
} from '@mui/material';
import ProgressBar from '../progress/progressBar';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from '@mui/material/TextField';
import './style.css';
import SearchIcon from '@mui/icons-material/Search';
import { DirectionContext } from '../../context/DirectionProvider';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ListPotentialMatches = (props) => {
  // const history = useHistory();
  const [progressFlag, setProgressFlag] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [recordsFromApi, setRecordsFromApi] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Requested');
  const [paginationDisabled, setPaginationDisabled] = useState(false);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const direction = useContext(DirectionContext);

  const status_count = {
    completed: recordsFromApi.filter(item => item.review_status == "Completed").length,
    requested: recordsFromApi.filter(item => item.review_status == "Requested").length,
  }

  useEffect(() => {
    if (records && records.length > 0) {
      const vendorFilteredData = records.filter((row) =>
        (row.Id && row.Id.toLowerCase().includes(searchTerm)) ||
        (row.created_at && row.created_at.toLowerCase().includes(searchTerm)) ||
        (row.updated_at && row.updated_at.toLowerCase().includes(searchTerm)) ||
        (row.review_status && row.review_status.toLowerCase().includes(searchTerm))
      ).filter(row => statusFilter === "All" || row.review_status == statusFilter)

      setFilteredRecords(vendorFilteredData);
    }

    setPaginationDisabled(!!searchTerm);
  }, [searchTerm, records, statusFilter, recordsFromApi])

  const handleError = (error) => {
    alert("Error:" + error)
    let errorDetail = error;
    setProgressFlag(false)
  };


  const getStatusClassdcr = (state) => {
    switch (state) {
      case CONSTANT.STATE[0]:
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[1]:
        return 'text-white rounded py-2 px-3 bg-success';
      case CONSTANT.STATE[2]:
        return 'text-white rounded py-2 px-3 bg-danger';
      case CONSTANT.STATE[3]:
        return 'text-white rounded py-2 px-3 bg-warning';
      case CONSTANT.STATE[4]:
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[5]:
        return 'text-white rounded py-2 px-3 bg-success';
      case CONSTANT.STATE[6]:
        return 'text-white rounded py-2 px-3 bg-danger';
      case CONSTANT.STATE[7]:
        return 'text-white rounded py-2 px-3 bg-success';
      case 'AWAITING_REVIEW':
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[9]:
        return 'text-white rounded py-2 px-3 bg-success';
      default:
        return 'text-white rounded py-2 px-3 bg-primary';
    }
  }

  const goToHome = () => {
    props.history.push('/');
  }

  const goBack = () => {
    props.history.goBack();
  };

  const handleChangePage = (event, newPage) => {
    if (searchTerm) {
      return;
    }
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const records = [...recordsFromApi];

  const vendorIndexStart = page * rowsPerPage;
  const vendorIndexEnd = page * rowsPerPage + rowsPerPage;
  const vendorDataPaginated = records.slice(vendorIndexStart, vendorIndexEnd);


  useEffect(() => {
    fetchData()
  }, []);

  async function fetchData() {
    await api
      .listPotentialMatches()
      .then(response => {
        let sortedResults = response.data?.records ?? []
        sortedResults.sort((a, b) => {
          if (moment.utc(new Date(a.created_at)).isAfter(moment.utc(new Date(b.created_at)))) {
            return -1;
          } else {
            return 1;
          }
        })
        setRecordsFromApi(sortedResults)
        setFilteredRecords(sortedResults)
      })
      .catch(error => {
        handleError(error)
      })
      .finally(() => setProgressFlag(false))

  };

  return (

    <section className={"container body-height extra-margin-top-less"}>
      {
        progressFlag
        &&
        <div className="d-flex justify-content-center extra-margin-top">
          <ProgressBar />
        </div>
      }
      {
        !progressFlag &&
        <>
          <Paper square className='mb-2'>
            <Stack direction={'row'} gap={0} justifyContent={'space-between'} alignItems={'center'}>
              <div className="tabdata">
                <ul className="nav">
                  <li id="track-head"
                    className={`active _wg-exclude`}>
                    Multi Matches
                  </li>
                  <li id="track-head"
                    className={`_wg-exclude`}>
                    <Link to="/no-matches">No Match</Link>
                  </li>
                </ul>
              </div>
              <Stack direction={'row'} gap={1}>
                <Tooltip disableFocusListener title="Back" id="tooltip">
                  <IconButton aria-label="back"
                    className="text-danger float-end"
                    onClick={goBack} color="secondary">
                    <ArrowBackIcon sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
                  </IconButton>
                </Tooltip>
                <IconButton aria-label="home" onClick={goToHome} className=' float-end'
                  color="secondary">
                  <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                    <HomeIcon className="text-danger "
                    />
                  </Tooltip>
                </IconButton>
              </Stack>
            </Stack>
          </Paper>
          <div className="outlet">
            <div className="search-bar mx-3 py-2">
              <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={6}>
                  <SearchIcon style={{ color: 'grey', fontSize: '20px', marginTop: '7px', marginRight: '4px' }} />
                  <TextField id="standard-basic"
                    type="text"
                    className="placeholder-text"
                    placeholder={'Type here to filter the requests...'} style={{ width: '380px' }} variant="standard" value={searchTerm} onChange={(event) => {
                      const inutSearchTerm = event.target.value.toLowerCase(); // Convert search term to lowercase
                      setSearchTerm(inutSearchTerm);
                    }} />
                </Grid>
                <Grid item xs={12} sm={6} style={{textAlign: 'right'}}>
                  <StatusFilter onChange={val => {
                    setStatusFilter(val)
                  }} />
                </Grid>
              </Grid>
            </div>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <caption><b>Completed: </b>{status_count.completed} | <b>Pending: </b> {status_count.requested}</caption>
                <TableHead className='_wg-dynamic-text'>
                  <TableRow>
                    <TableCell className='font' align="center"><Typography variant='subtitle1' className='fw-bold'>Request Id</Typography></TableCell>
                    <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold' >Created Time</Typography></TableCell>
                    <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'> Updated Time</Typography></TableCell>
                    <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Status</Typography></TableCell>
                    <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Action</Typography></TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    filteredRecords.length === 0 ? (
                      <TableRow className='_wg-dynamic-text'>
                        <TableCell colSpan={6} align="center">
                          No Requests Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      (filteredRecords).map((row) => (
                        <TableRow key={row.Id}>
                          <TableCell align="left" component="th" scope="row">{row.Id}</TableCell>
                          <TableCell align="left">{row.created_at?? ' - '}</TableCell>
                          <TableCell align="left">{(row.updated_at?? ' - ')}</TableCell>
                          <TableCell align="center"><span className={`${getStatusClassdcr(row.review_status)} statusWidth`}>{row.review_status ?? 'Unknown'} </span></TableCell>

                          <TableCell align="center" className='_wg-dynamic-text'><Button className='linkButton' component={Link} to={`/potential-matches/view/${row.Id}`}>View details</Button></TableCell>
                        </TableRow>
                      )))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 15, 25]}
              component="div"
              count={filteredRecords.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              id="track-head"
              slotProps={{
                actions: {
                  previousButton: {
                    disabled: page === 0 || paginationDisabled,
                  },
                  nextButton: {
                    disabled: page >= Math.ceil(filteredRecords.length / rowsPerPage) - 1 || paginationDisabled
                  }
                }
              }}
            />
          </div>
        </>
      }
    </section>
  );
};


function StatusFilter(props) {
  const [value, setValue] = React.useState('Requested');
  const { onChange } = props

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <InputLabel id="demo-select-small-label">Status</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={value}
        label="Status"
        onChange={handleChange}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Requested">Requested</MenuItem>
        <MenuItem value="Completed">Completed</MenuItem>
      </Select>
    </FormControl>
  );
} 

export default ListPotentialMatches;
